<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 掲示板（コメント）詳細（追加・編集・閲覧）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>掲示板（コメント）詳細（追加・編集・閲覧）の説明</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/board-comment-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> コメント
        </div>
        <div class="manual-explain">
          コメントを設定します。<br>
          閲覧時には設定できません。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 画像
        </div>
        <div class="manual-explain">
          画像を設定します。<br>
          閲覧時には設定できません。
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることでコメントが削除されます。<br>
          閲覧時には表示されません。
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。<br>
          閲覧時には表示されません。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Bulletin Board (Comments) Details (Add/Edit/View) Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Bulletin Board (Comments) Details (Add/Edit/View) Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/en_board-comment-dialog.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Close Button
          </div>
          <div class="manual-explain">
            Clicking this button closes the dialog.<br>
            Edited content will not be saved.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Comment
          </div>
          <div class="manual-explain">
            Set the comment.<br>
            Cannot be set during view mode.<br>
            <span class="manual-explain-notes">*Required field</span>
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Image
          </div>
          <div class="manual-explain">
            Set the image.<br>
            Cannot be set during view mode.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/D.png"> Delete Button
          </div>
          <div class="manual-explain">
            Clicking this button deletes the comment.<br>
            Not displayed in view mode.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/E.png"> Update Button
          </div>
          <div class="manual-explain">
            Clicking this button updates the edited content.<br>
            Not displayed in view mode.
          </div>
        </mat-card-content>
      </mat-card>

  </div>
</div>
